import React from 'react';

import PropTypes from 'prop-types';

import { DASHBOARD_ITEM_API_NAMES } from '@src/constants/commons';

import DashboardWidget from '../DashboardWidget';
import { scheduleComplianceChartConfig } from '../DashboardWidget/configs';

const BarChartCard = ({ chart, onEdit, refresh, filters }) => {
  /*
    We can have multiple bar charts with different configs (different data sources, different value types, different group by options, etc.)
    so we need to use a map of configs to get the correct config for the given chart.
   */
  const configs = {
    [DASHBOARD_ITEM_API_NAMES.SCHEDULES_COMPLIANCE]: scheduleComplianceChartConfig,
  };

  return (
    <DashboardWidget
      widget={chart}
      onEdit={onEdit}
      refresh={refresh}
      filters={filters}
      config={configs[chart.apiName] || scheduleComplianceChartConfig}
    />
  );
};

BarChartCard.propTypes = {
  chart: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  refresh: PropTypes.bool.isRequired,
  filters: PropTypes.object.isRequired,
};

export default BarChartCard;
